/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Reactivate_HintInputs */



/**
* | output |
* | --- |
* | "This space is paused. Reactivate it to restore member access and resume sync." |
*
* @param {Spaces_Reactivate_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_reactivate_hint = /** @type {((inputs?: Spaces_Reactivate_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Reactivate_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Space ist pausiert. Reaktiviere ihn, um den Mitgliederzugriff wiederherzustellen und den Sync fortzusetzen.")
	return /** @type {LocalizedString} */ ("This space is paused. Reactivate it to restore member access and resume sync.")
});